import { render, staticRenderFns } from "./BillOfLanding.vue?vue&type=template&id=9bb3b798"
import script from "./BillOfLanding.vue?vue&type=script&lang=js"
export * from "./BillOfLanding.vue?vue&type=script&lang=js"
import style0 from "./BillOfLanding.vue?vue&type=style&index=0&id=9bb3b798&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports